<script lang="ts">
  import * as _ from "lodash";
  export let type;
  export let width = null;
  export let height = null;
  export let className;
  export let extraClassNames = "";
  export let onPress = null;
  export let color: string = null;
  export let fill: string = null;
  export let transform: string = null;
  export let centered = false;
  export let extraStyles: string = "";
  export let opacity = 1;
  export let id: string = null;
  export let dataTestId: string = null;

  function iconClass() {
    return (className || "") + " svg-icon" + " " + extraClassNames;
  }

  function svgStyle() {
    let styles = `opacity: ${opacity}; `;
    if (color) {
      styles += `color: ${color}; `;
    }
    if (fill) {
      styles += `fill: ${fill}; `;
    }
    if (height && width) {
      styles += `height: ${height}px; width: ${width}px; `;
    }
    if (transform) {
      styles += `transform: ${transform};`;
    }
    if (centered) {
      styles += `margin-left: auto; margin-right:auto;`;
    }
    return styles;
  }

  function onPressWrapper(event) {
    if (onPress) {
      onPress(event);
    }
  }
  let svgStyleValue = svgStyle();
  let iconClassValue = iconClass();
  $: {
    color = color;
    className = className;
    svgStyleValue = svgStyle();
    iconClassValue = iconClass();
  }

</script>

<svg
  role="img"
  style={`${svgStyleValue} ${extraStyles}`}
  class={iconClassValue}
  on:click={onPressWrapper}
  {id}
  data-testid={dataTestId || id}
>
  <use xlink:href="#{type}" />
</svg>
